var map = {
	"./Portfolio/apidemo.png": 719,
	"./Portfolio/gotmoney.jpg": 130,
	"./Portfolio/resume-website.jpg": 893,
	"./Portfolio/texttospeech.png": 620,
	"./loader.gif": 473,
	"./logo-orginal.png": 721,
	"./logo.png": 206,
	"./logo.svg": 690,
	"./placeholder.png": 652,
	"./profilepic.jpg": 350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 187;